'use strict';

if ( !String.prototype.trim ) {
	( function stringTrimBootstrap() {
		// Make sure we trim BOM and NBSP
		var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
		String.prototype.trim = function stringTrim() {
			return this.replace( rtrim, '' );
		};
	})();
}

module.exports = String.prototype.trim;
